import { render, staticRenderFns } from "./DemoRequests.vue?vue&type=template&id=63042f98&scoped=true&"
import script from "./DemoRequests.vue?vue&type=script&lang=js&"
export * from "./DemoRequests.vue?vue&type=script&lang=js&"
import style0 from "./DemoRequests.vue?vue&type=style&index=0&id=63042f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63042f98",
  null
  
)

export default component.exports